import React, { useCallback, useEffect, useState } from 'react';
import { CLAIMEDS, STAKES } from '../../../api/queries';
import { unifarmFactory } from '../../../utils/contract';
import { apiRequest } from '../../../api/apiService';
import useWallet from '../../../hooks/useWallet';
import { useStake } from '../../../hooks/useStake';

function ProfileStats({ rootPoolsCount, childPoolsCount, dummyData }) {

    const { address } = useWallet();
    const { getRewards } = useStake();
    const [totalRewardClaimed, setTotalRewardClaimed] = useState(0);
    const [claimableReward, setClaimableReward] = useState(0);
    // console.log(dummyData, 'address in profile stats')
    const fetchTotalStakers = useCallback(async () => {
        try {
            const response = await apiRequest({
                url: unifarmFactory.rootTokens,
                method: "POST",
                data: {
                    query: CLAIMEDS,
                    variables: {
                        where: { staker: address },
                    },
                },
                auth: false,
            });

            const claimData = response?.data?.claimeds || [];
            // console.log("Failed to fetch total stakers:", claimData);
            // Sum all claimed rewards
            const total = claimData.reduce((acc, item) => {
                const claimed = parseFloat(item?.reward) / 1e18;
                return acc + claimed;
            }, 0);

            setTotalRewardClaimed(total);
            const response2 = await apiRequest({
                url: unifarmFactory.rootTokens,
                method: "POST",
                data: {
                    query: STAKES,
                    variables: {
                        where: {},
                    },
                },
                auth: false,
            });

            const stakeData = response2?.data?.stakes || [];
            // console.log("Failed to fetch total stakers ---:", stakeData);
            // Fetch claimable rewards for all contracts
            if (stakeData.length > 0) {
                await fetchClaimableRewards(stakeData);
            }
        } catch (error) {
            console.error("Failed to fetch total stakers:", error);
        }
    }, [address]);

    // const fetchClaimableRewards = async (stakes) => {
    //     try {
    //         // Fetch rewards for all contracts in parallel
    //         const rewardsPromises = stakes.map(async (stake) => {
    //             if (!stake?.contract) return 0;

    //             try {
    //                 const rewardsData = await getRewards(stake.contract, address);
    //                 // console.log(rewardsData, `Failed to fetch claimable rewards:----------> ${stake.contract}:`);
    //                 return parseFloat(rewardsData?.rewardsETH || 0);
    //             } catch (error) {
    //                 console.error(`Failed to fetch claimable rewards:---------->1 ${stake.contract}:`, error);
    //                 return 0;
    //             }
    //         });

    //         const rewardsArray = await Promise.all(rewardsPromises);
    //         // console.log(rewardsArray, 'Failed to fetch claimable rewards:---------->')
    //         const totalClaimable = rewardsArray.reduce((acc, reward) => acc + reward, 0);

    //         setClaimableReward(totalClaimable);
    //     } catch (error) {
    //         console.error("Failed to fetch claimable rewards:---------->", error);
    //     }
    // };
    const fetchClaimableRewards = async (stakes) => {
        try {
            const BATCH_SIZE = 5;
            let totalClaimable = 0;

            // Process stakes in batches of 5
            for (let i = 0; i < stakes?.length; i += BATCH_SIZE) {
                const batch = stakes?.slice(i, i + BATCH_SIZE);

                // Fetch rewards for this batch in parallel
                const rewardsPromises = batch?.map(async (stake) => {
                    if (!stake?.contract) return 0;

                    try {
                        const rewardsData = await getRewards(stake?.contract, address);
                        return parseFloat(rewardsData?.rewardsETH || 0);
                    } catch (error) {
                        console.error(`Failed to fetch claimable rewards: ${stake?.contract}:`, error);
                        return 0;
                    }
                });

                const batchRewards = await Promise.all(rewardsPromises);
                const batchTotal = batchRewards.reduce((acc, reward) => acc + reward, 0);
                totalClaimable += batchTotal;
            }

            setClaimableReward(totalClaimable);
        } catch (error) {
            console.error("Failed to fetch claimable rewards:", error);
        }
    };
    useEffect(() => {
        if (address) fetchTotalStakers();
    }, [address, fetchTotalStakers, dummyData]);

    return (
        <div className="chart_side">
            <div className="inner_future">
                <p>Root Pool Created</p>
                <h4>{rootPoolsCount}</h4>
            </div>
            <div className="inner_future">
                <p>Child Pool Created</p>
                <h4>{childPoolsCount}</h4>
            </div>
            <div className="inner_future">
                <p>Total Reward Claimed</p>
                <h4>{totalRewardClaimed ? parseFloat(totalRewardClaimed)?.toFixed(5) : 0}</h4>
            </div>
            <div className="inner_future">
                <p>Claimable Reward</p>
                <h4>{claimableReward ? claimableReward.toFixed(5) : 0}</h4>
            </div>
        </div>
    );
}

export default ProfileStats;